import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-surface-secondary text-secondary',
        draft: 'bg-surface-secondary text-secondary',
        inactive: 'bg-surface-secondary text-secondary',
        submitted: 'bg-info/10 text-info',
        manager: 'bg-warning/20 text-warning',
        cluster: 'bg-accent-300/10 text-accent-300',
        approved: 'bg-success/10 text-success',
        rejected: 'bg-error/10 text-error',
        'rejected-cluster': 'bg-error/20 text-error',
        returned: 'bg-warning/15 text-warning',
        success: 'bg-success/10 text-success',
        danger: 'bg-error/10 text-error',
        warning: 'bg-warning/20 text-warning',
        info: 'bg-info/10 text-info',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
